import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { EditFaqRequest } from '@/types/request/EditFaqRequest';
import { queryClient } from '@/main.tsx';

const useFaqEdit = () => {
  const client = supabaseClient;

  const mutationFn = async (request: EditFaqRequest) => {
    return editFaq(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['faq'] });
    },
  });
};

export default useFaqEdit;

async function editFaq(client: SupabaseClient, request: EditFaqRequest): Promise<void> {
  const { data: question, error: errorQuestion } = await client
    .from('questions')
    .update({
      restaurant_id: request.restaurant_id,
      question: request.question,
    })
    .eq('id', request.id)
    .select('id')
    .maybeSingle();

  if (errorQuestion) throw new Error(errorQuestion.message);
  if (!question) throw new Error('Failed to update FAQ. Try with another question.');

  const { data: answer, error: errorAnswer } = await client
    .from('answers')
    .upsert(
      {
        question_id: question.id,
        answer: request.answer,
      },
      { onConflict: 'question_id' }
    )
    .select('id')
    .maybeSingle();

  if (errorAnswer) throw new Error(errorAnswer.message);
  if (!answer) throw new Error('Failed to update FAQ. Try with another answer.');

  return;
}
